import { useEffect, useState, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export function Lightbox({ images, index, onClose }) {
  const [i, setI] = useState(index);
  const [touchX, setTouchX] = useState(null);
  const prev = useCallback(() => setI(n => (n - 1 + images.length) % images.length), [images.length]);
  const next = useCallback(() => setI(n => (n + 1) % images.length), [images.length]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); if (e.key === "ArrowLeft") prev(); if (e.key === "ArrowRight") next(); };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose, prev, next]);

  const onTouchEnd = (e) => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (dx > 50) prev(); else if (dx < -50) next();
    setTouchX(null);
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center" onClick={onClose} data-testid="lightbox"
         onTouchStart={e => setTouchX(e.touches[0].clientX)} onTouchEnd={onTouchEnd}>
      <button onClick={onClose} className="absolute top-4 right-4 text-white/80 hover:text-white p-2" aria-label="Close" data-testid="lightbox-close"><X className="w-7 h-7"/></button>
      <button onClick={e => { e.stopPropagation(); prev(); }} className="absolute left-2 md:left-6 text-white/80 hover:text-white p-2" aria-label="Previous" data-testid="lightbox-prev"><ChevronLeft className="w-9 h-9"/></button>
      <img src={images[i]} alt="" onClick={e => e.stopPropagation()} className="max-h-[88vh] max-w-[92vw] object-contain select-none" data-testid="lightbox-image"/>
      <button onClick={e => { e.stopPropagation(); next(); }} className="absolute right-2 md:right-6 text-white/80 hover:text-white p-2" aria-label="Next" data-testid="lightbox-next"><ChevronRight className="w-9 h-9"/></button>
      <div className="absolute bottom-4 text-white/70 text-xs tracking-widest" data-testid="lightbox-counter">{i + 1} / {images.length}</div>
    </div>
  );
}
